import { HttpInterceptorFn } from '@angular/common/http';

const SITE_HEADER_NAME = 'site';
const SITE_HEADER_VALUE = 'qca';

export const siteHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  return next(
    req.clone({
      setHeaders: {
        [SITE_HEADER_NAME]: SITE_HEADER_VALUE
      }
    })
  );
};
